'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypeIcon = function getTypeIcon(props) {
  var post = props.post;

  var isStory = _lodash2.default.get(post, 'trackedAsset.assetType', null) === 'STORY';
  var isIGTV = _lodash2.default.get(post, 'isIGTV', false);
  var isReel = _lodash2.default.get(post, 'isReel', false);
  var isVideo = post.isVideo || post.viewCount;

  if (isIGTV) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'tv', color: 'pink' });
  if (isReel) {
    return _react2.default.createElement(_semanticUiReact.Image, {
      src: 'https://app.dyzio.co/images/reels-pink.png',
      style: { display: 'inline', width: 13, height: 13 }
    });
  }

  if (isStory) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle outline', color: 'pink' });

  if (isVideo) return _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'pink' });

  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone outline', color: 'pink' });
};

var InstagramIcon = function InstagramIcon(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
    getTypeIcon(props)
  );
};

InstagramIcon.propTypes = {
  post: _propTypes2.default.object.isRequired
};

exports.default = InstagramIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/instagram-icon/index.js
 ** module id = 972
 ** module chunks = 0
 **/